import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function SafetyPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('safetyH1')} | CSSBuy Spreadsheet`;
  }, [t]);

  const safetyItems = [
    { icon: 'ri-links-line', title: t('safetyUrlVerify'), desc: t('safetyUrlVerifyText') },
    { icon: 'ri-lock-password-line', title: t('safetyPassword'), desc: t('safetyPasswordText') },
    { icon: 'ri-secure-payment-line', title: t('safetyPayment'), desc: t('safetyPaymentText') },
    { icon: 'ri-file-info-line', title: t('safetyProductInfo'), desc: t('safetyProductInfoText') },
    { icon: 'ri-customer-service-2-line', title: t('safetyCustoms'), desc: t('safetyCustomsText') },
    { icon: 'ri-folders-line', title: t('safetyRecords'), desc: t('safetyRecordsText') },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('breadcrumbSafety')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('safetyH1')}
            </h1>
            <p className="text-lg text-foreground-700 leading-relaxed mb-10 max-w-3xl">
              {t('safetyIntro')}
            </p>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-10">
              {safetyItems.map((item, index) => (
                <div key={index} className="bg-background-100 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-3">
                    <i className={`${item.icon} text-accent-600`} style={{ width: 20, height: 20 }} />
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2 text-sm">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="bg-primary-50 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-700 flex items-start gap-2">
                <i className="ri-information-line text-primary-500 mt-0.5 flex-shrink-0" style={{ width: 16, height: 16 }} />
                <span>{t('footerDisclaimerText')}</span>
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <h3 className="font-semibold text-foreground-950 mb-4">{t('articleRelated')}</h3>
              <div className="flex flex-wrap gap-3">
                <Link to="/cssbuy-spreadsheet" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('breadcrumbSpreadsheet')}</Link>
                <Link to="/cssbuy-review" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navReview')}</Link>
                <Link to="/cssbuy-guide" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navGuide')}</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}